import { useEffect, useState } from "react";
import {AddCategory, ContainerGifs} from "./components";
import { saveLocalStorage } from "./helpers/saveLocalStorage";
import { getLocalStorage } from "./helpers/getLocalStorage";

const App = () => {
    const [categories, setCategories] = useState([]);
    const [checkDeleted, setCheckDeleted] = useState(false);

    useEffect(() => {
        setCategories(getLocalStorage());
    },[checkDeleted]);

    const handleAddElement = (element) => {
        // Validate
        if(element.trim().length <= 1)return;

        if(categories.includes(element))return;
        else{
            saveLocalStorage(element);
            setCategories([...categories, element]);
        }
    }

    return(
        <div>
            <h1>Search your gifs!</h1>
            <p className = "mr-5">Reload the page and they will continue there</p>
            <p className = "mr-5">Developed by Paolo Cisneros</p>
            <AddCategory handleAddElement = {handleAddElement} />
            {
                categories.length === 0 && <p class = "m-10">There are not names in your list.</p>
            }
            <div class = "container">
                {
                categories.map(category => (
                    <ContainerGifs key = {category} category = {category} setCheckDeleted = {setCheckDeleted} checkDeleted = {checkDeleted} />
                    ))
                }
            </div>
        </div>
    )
}
export default App;
